import { render, staticRenderFns } from "./ProductImageToggle.vue?vue&type=template&id=67bebb0e&"
import script from "./ProductImageToggle.vue?vue&type=script&lang=js&"
export * from "./ProductImageToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports